import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import LoginModal from '../LoginModal';
import FreeCoursesSection from '../FreeCoursesSection';
import CoursesSection from '../CoursesSection';
import PartnershipsSection from '../PartnershipsSection';
import SEO from '../SEO';
import CurrencyWelcomeNotice from '../CurrencyWelcomeNotice';
import { Badge } from '../ui/badge';

const AcademyPage = () => {
  const navigate = useNavigate();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <>
      <SEO 
        title="AJ|BIM Academy - Cursos de BIM e Revit"
        description="Cursos e formações completas em BIM, Revit, Navisworks. Do básico ao avançado. +12.000 alunos formados desde 2005."
        keywords="cursos BIM, Revit, Navisworks, formação BIM, treinamento Revit"
      />
      <Header onLoginClick={() => setIsLoginModalOpen(true)} />
      <CurrencyWelcomeNotice />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-red-900/30 via-black to-black">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-red-600/10 border border-red-500/30 rounded-full px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
              <span className="text-red-400 text-sm font-medium">Líder em Educação BIM no Brasil</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Cursos e Formações <span className="text-red-500">BIM</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Do básico ao expert em Revit, Navisworks e metodologia BIM. 
              Formações completas com certificado reconhecido pelo mercado.
            </p>
          </div>
        </div>
      </section>

      {/* Banner Formação BIM Expert (largura total) */}
      <a
        href="/formation/6"
        className="block w-full bg-black group"
        data-testid="academy-bim-expert-banner"
        aria-label="Conheça a Formação BIM Expert"
      >
        <img
          src="https://static.prod-images.emergentagent.com/jobs/2b41e164-3d6f-488e-a974-c4593600dbb3/images/9dfb54a14aa6d036c6e4df7aa51f90b8d658212ccaf0a76a7209e36ad225de80.jpeg"
          alt="Formação BIM Expert - A mais completa do Brasil e da América Latina"
          className="w-full h-auto block transition-opacity duration-300 group-hover:opacity-95"
        />
      </a>

      {/* Cursos Gratuitos */}
      <FreeCoursesSection />

      {/* Formações e Cursos Pagos */}
      <CoursesSection onLoginClick={() => setIsLoginModalOpen(true)} />

      {/* Parcerias e Convênios (com relação de descontos) */}
      <PartnershipsSection show="agreements" />

      {/* CTA - Teste seu Conhecimento */}
      <section className="py-16 bg-gradient-to-r from-red-900/30 via-black to-red-900/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <Badge className="bg-yellow-600/20 text-yellow-400 border-yellow-500/30 mb-4">
              Avaliação Gratuita
            </Badge>
            <h2 className="text-3xl font-bold text-white mb-4">
              Teste seu Conhecimento em <span className="text-red-500">Revit</span>
            </h2>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
              Antes de investir em capacitação, descubra seu nível atual em Autodesk Revit. 
              Ao final, receba um certificado ou recomendações de cursos personalizadas.
            </p>
            <Button
              onClick={() => navigate('/avaliacao-revit')}
              className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-6 text-lg"
            >
              TESTE SEU CONHECIMENTO EM REVIT
            </Button>
            <div className="flex justify-center gap-8 mt-8 text-sm text-gray-500">
              <span>✓ 20 questões</span>
              <span>✓ Resultado imediato</span>
              <span>✓ Certificado ao passar</span>
            </div>
          </div>
        </div>
      </section>

      {/* Voltar */}
      <section className="py-12 bg-black">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-zinc-700 text-white hover:bg-zinc-800"
          >
            <ArrowLeft className="mr-2" size={18} />
            Voltar ao Portal
          </Button>
        </div>
      </section>

      <Footer />
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  );
};

export default AcademyPage;
